import { render, staticRenderFns } from "./PdDetailsSummary.vue?vue&type=template&id=14e32b37&scoped=true&"
import script from "./PdDetailsSummary.vue?vue&type=script&lang=js&"
export * from "./PdDetailsSummary.vue?vue&type=script&lang=js&"
import style0 from "./PdDetailsSummary.vue?vue&type=style&index=0&id=14e32b37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e32b37",
  null
  
)

export default component.exports